export enum TwoFactorAuthType {
    GoogleAuthenticator = 'GoogleAuthenticator',
    SMS = 'SMS',
    Invalid = 'Invalid',
}
